import {MetadataConfigItem, MetadataItem} from 'api/generated';
import {Hint} from 'components';
import React from 'react';
import styled from 'styled-components';
import {getMetadataHint, getMetadataLabel} from '../utils';

type Props = {
  item: MetadataConfigItem | MetadataItem;
};

const Label = styled.span`
  margin-right: 0.5em;
`;

export const MetadataLabel: React.FC<Props> = ({item}) => {
  return (
    <>
      <Label>{getMetadataLabel(item)}</Label>
      <Hint overlayInnerStyle={{minWidth: 400}} message={getMetadataHint(item)} />
    </>
  );
};
